module.exports = __webpack_public_path__ + "img/duel_frontier.bf4d4b16.png";